<template>
  <div class="chat-configure-form mt-4">
    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs:minmax(0, 1fr);--pc-inline-grid-gap-xs:var(--p-space-400)"
    >
      <!-- Left column: Configuration options -->
      <div style="display:inherit;width:auto;border-inline-start:none">
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row"
        >
          <div style="color:var(--p-color-text-info-on-bg-fill);width:100%">
            <div class="Polaris-LegacyCard">
              <!-- Desktop Settings Header Section -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Desktop Settings
                    </h2>
                    <p class="mt-1 text-sm leading-5 text-gray-500">
                      Configure your whatsapp chat button for Desktop
                    </p>
                  </div>
                </div>
              </div>

              <!-- Enable Desktop Section -->
              <div class="Polaris-LegacyCard__Section border-b border-gray-200">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Enable on Desktop
                    </h2>
                  </div>
                </div>

                <div class="mt-4 flex flex-wrap">
                  <VSwitch v-model="config.desktop.isEnabled" />
                </div>
              </div>

              <!-- Position Settings Section -->
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Position & Dimensions
                    </h2>
                  </div>
                </div>

                <div
                  class="Polaris-BlockStack"
                  style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)"
                    role="group"
                  >
                    <div
                      class="Polaris-InlineGrid"
                      style="--pc-inline-grid-grid-template-columns-xs:repeat(2, minmax(0, 1fr));--pc-inline-grid-gap-xs:var(--p-space-400)"
                    >
                      <!-- Right Position -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Right position</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                v-model="config.dimensions.rightPosition"
                                type="number"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Left Position -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Left position</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                v-model="config.dimensions.leftPosition"
                                type="number"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Bottom Position -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Bottom position</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                v-model="config.dimensions.bottomPosition"
                                type="number"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Button Text Font Size -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Button text font size</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                v-model="config.dimensions.buttonTextFontSize"
                                type="number"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- WhatsApp Icon Size -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >WhatsApp icon size</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                v-model="config.dimensions.iconSize"
                                type="number"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSwitch from "../../components/Common/VSwitch";

export default {
  components: {
    VSwitch
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    hasMoreCharacters() {
      const label = this.config.welcomeMessage?.text || "";
      return label.length > 40;
    }
  },
  methods: {
    save() {
      this.$emit("save");
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-configure-form .Polaris-LegacyCard {
  overflow: visible;
}

.chat-configure-form .Polaris-Connected__Item--primary {
  z-index: unset;
  position: unset;
}

.chat-configure-form .Polaris-Connected__Item--primary:focus {
  z-index: 10000;
}
</style>
